import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Text } from '@actual-app/components/text';
import { View } from '@actual-app/components/view';
import { send } from '@actual-app/core/platform/client/connection';

import { Boton } from '#components/mobile/ui/Boton';
import { color, texto } from '#components/mobile/ui/tokens';

import { LlaveRepuesto } from './LlaveRepuesto';
import { mensajeErrorCofre } from './PantallaCofre';

/**
 * Ajustes › Cuenta: crear otra llave de repuesto para quien perdió la suya
 * (o nunca la guardó). La anterior deja de servir.
 */
export function NuevaLlaveRepuesto() {
  const { t } = useTranslation();
  const [llave, setLlave] = useState<string | null>(null);
  const [creando, setCreando] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [guardada, setGuardada] = useState(false);

  async function crear() {
    setCreando(true);
    setError(null);
    const res = await send('cofre-nueva-llave-repuesto');
    setCreando(false);
    if (res.error || !res.llaveRepuesto) {
      setError(mensajeErrorCofre(t, res.error ?? 'sin-conexion'));
      return;
    }
    setGuardada(false);
    setLlave(res.llaveRepuesto);
  }

  if (llave) {
    return (
      <LlaveRepuesto
        llave={llave}
        onContinuar={() => {
          setLlave(null);
          setGuardada(true);
        }}
      />
    );
  }

  return (
    <View style={{ gap: 12 }}>
      <Text style={{ ...texto.cuerpo, color: color.fg2 }}>
        <Trans>
          The spare key opens your data if you forget your Rumbo password. If
          you lost it or never saved it, create a new one: the old one will stop
          working.
        </Trans>
      </Text>
      {guardada && (
        <Text role="status" style={{ ...texto.cuerpo, color: color.accent }}>
          <Trans>Your new spare key is ready. Keep it safe.</Trans>
        </Text>
      )}
      {error && (
        <Text role="alert" style={{ ...texto.cuerpo, color: color.bad }}>
          {error}
        </Text>
      )}
      <Boton
        bloque
        data-testid="repuesto-crear"
        isDisabled={creando}
        onPress={() => void crear()}
      >
        {creando ? t('Creating…') : t('Create a new spare key')}
      </Boton>
    </View>
  );
}
